export enum CheckinTemplateDetailMenuEnum {
  CLASSES = 'CLASSES',
  CHILD_REFERENCES = 'CHILD_REFERENCES'
}

export interface CheckinTemplateDetailMenuEntry {
  value: CheckinTemplateDetailMenuEnum;
  label: string;
}

export const CHECKIN_TEMPLATE_DETAIL_MENU_ENTRIES: CheckinTemplateDetailMenuEntry[] = [
  {
    value: CheckinTemplateDetailMenuEnum.CLASSES,
    label: 'DESIGN_B.CHECKIN_TEMPLATE.DETAIL_PAGE.MENU.CLASSES'
  },
  {
    value: CheckinTemplateDetailMenuEnum.CHILD_REFERENCES,
    label: 'DESIGN_B.CHECKIN_TEMPLATE.DETAIL_PAGE.MENU.CHILD_REFERENCES'
  }
];
